module.exports = __webpack_public_path__ + "img/pink25.6857c02e.png";